module.exports = __webpack_public_path__ + "img/LAOPU-icon.b83aba3a.jpg";